import 'react-phone-number-input/style.css'
import "./styles.css"
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'

function CustomPhoneInput({value, onChange, noPadding, ...rest}) {
  
  const handleChange = (phoneNumber) => {
    if(phoneNumber){
      const phoneDetails = parsePhoneNumber(phoneNumber);
      const countryCode = phoneDetails?.countryCallingCode || "+1";
      const country = phoneDetails?.country || "US";
      const actualNumber = phoneDetails?.nationalNumber || "";
      onChange({ phoneNumber, countryCode, country, actualNumber });
    }
    else {
      onChange({ phoneNumber: '', countryCode: '', country: '' });
    }
  }

  return (
    <div className={`custom-phone-input ${noPadding ? "signup-phone-input" : ""}` }>
      <PhoneInput
        placeholder="Enter phone number"
        value={value}
        onChange={handleChange}
        defaultCountry='US'
        // P5S1-Y4: force international format so the numeric dial code (+1/+44/...)
        // is always visible in the input, not just the flag — country-select alone
        // gave the user no confirmation of which code was actually being submitted.
        international
        // D-16: the country calling code (+1/+44/...) is LOCKED / non-deletable.
        // Without this, backspacing at the start of the field erases the dial
        // code and corrupts the value into a neutral/invalid state. With it, the
        // calling code stays put (a valid country is always retained) even when
        // the user erases every other digit. Applied here in the SHARED wrapper
        // so every surface (signup, phone-OTP/2FA, profile/settings, referrals)
        // inherits the lock, not just the ones that opted in ad-hoc.
        countryCallingCodeEditable={false}
        {...rest}
      />
    </div>
  )
}

export default CustomPhoneInput